import { SxProps } from '@mui/material';

type ServiceVariantLike = {
  id?: number | string | null;
  ref?: string | null;
  name?: string | null;
  service?: {
    name?: string | null;
  } | null;
} | null;

export type BookingServiceIcon = {
  icon: string;
  title: string;
  sx?: SxProps;
};

const HOLIDAY_RENTAL_VARIANT_ID = 4;
const COMMERCIAL_VARIANT_ID = 5;

export const getBookingServiceIcon = (
  serviceVariant?: ServiceVariantLike,
  fallbackServiceName?: string | null
): BookingServiceIcon | null => {
  const variantId = Number(serviceVariant?.id);
  const searchableText = [
    serviceVariant?.ref,
    serviceVariant?.name,
    serviceVariant?.service?.name,
    fallbackServiceName,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  if (
    variantId === HOLIDAY_RENTAL_VARIANT_ID ||
    searchableText.includes('holiday')
  ) {
    return {
      icon: 'logos:airbnb-icon',
      title: 'Holiday rental',
    };
  }

  if (
    variantId === COMMERCIAL_VARIANT_ID ||
    searchableText.includes('commercial') ||
    searchableText.includes('office')
  ) {
    return {
      icon: 'ph:building-office-light',
      title: 'Commercial',
      sx: { color: 'info.main' },
    };
  }

  return null;
};
